// #3294 -- sensor tuning for the sections page drag list. A mouse needs a small
// move before a drag starts (so a click on the handle is not a drag), touch
// needs a long press (so scrolling the list still scrolls), and the keyboard
// sensor is the non-pointer path. Bare HTML5 drag never fires on an iPad.
export const TOUCH_ACTIVATION = { delay: 250, tolerance: 8 };
export const MOUSE_ACTIVATION = { distance: 4 };
